module.exports = __webpack_public_path__ + "img/star.e4296c60.svg";